import React from 'react';
import { styled } from '@mui/material/styles';
import Skeleton from '@mui/material/Skeleton';
import { SummaryWidgetConfig } from '../../definitions/inventorySummary';
import useWidgetCount from '../../hooks/useWidgetCount';

const Card = styled('div', { shouldForwardProp: (prop) => prop !== 'accentColor' })<{ accentColor: string }>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  padding: '16px 20px',
  borderRadius: 12,
  border: '1px solid #eee',
  backgroundColor: '#fff',
  boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
  flex: '1 1 160px',
  minWidth: 160,
  [theme.breakpoints.down('sm')]: {
    flex: '0 0 160px',
  },
}));

const IconBadge = styled('div', { shouldForwardProp: (prop) => prop !== 'accentColor' })<{ accentColor: string }>(({ accentColor }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 40,
  height: 40,
  borderRadius: 10,
  backgroundColor: `${accentColor}1A`,
  color: accentColor,
}));

const Label = styled('div')({
  fontSize: 13,
  color: '#6b7280',
});

const Count = styled('div')({
  fontSize: 22,
  fontWeight: 700,
  color: '#1f2937',
});

interface SummaryWidgetCardProps {
  config: SummaryWidgetConfig;
}

const SummaryWidgetCard = ({ config }: SummaryWidgetCardProps) => {
  const { label, color, icon: Icon, key } = config;
  const { count, loading, error } = useWidgetCount(key);

  return (
    <Card accentColor={color}>
      <IconBadge accentColor={color}>
        <Icon />
      </IconBadge>
      <div>
        <Label>{label}</Label>
        {loading ? (
          <Skeleton width={48} height={28} />
        ) : (
          <Count>{error ? '—' : (count ?? 0).toLocaleString()}</Count>
        )}
      </div>
    </Card>
  );
};

export default SummaryWidgetCard;
